module.exports = __webpack_public_path__ + "res/ic_add_image.936a43be090dce356a660555d847ab4d.png";